/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

import { Tools } from '@helpers/Tools'
import { extend } from 'vee-validate/dist/vee-validate.full.esm'

extend('int', v => Tools.isNumeric(Tools.fromArabicNumber(v)))

extend('mobile', v => Tools.isKsaMobile(v))

extend('array_size', (v, a) => {
  if (!v) {
    return !0
  }
  const attr = parseInt(a) || 0
  return v.length <= attr
})

export default extend
